export default "__VITE_ASSET__7f31cc3c__"